const selectDevModeContext = (state: AnyFixMe) => state.devModeContext;

export { selectDevModeContext };
